import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCircleStrikethroughOutline = function SvgCircleStrikethroughOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47716 6.47716 2 12 2C14.7612 2 17.2622 3.1201 19.071 4.92892C20.8799 6.73775 22 9.23879 22 12C22 17.5228 17.5228 22 12 22C9.23879 22 6.73775 20.8799 4.92892 19.071C3.1201 17.2622 2 14.7612 2 12ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.0775 4.24452 15.9799 5.48253 17.4568L17.4568 5.48253C15.9799 4.24452 14.0775 3.5 12 3.5ZM18.5174 6.54318L6.54318 18.5174C8.02005 19.7555 9.92251 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 9.92251 19.7555 8.02005 18.5174 6.54318Z"
  })));
};

export { SvgCircleStrikethroughOutline as ReactComponent };
//# sourceMappingURL=circle--strikethrough-outline.svg.js.map
